import { create } from "zustand";

export const footerStore = create((set) => ({
  label: false,

  setLabel: (data) => {
    set(() => ({ label: data }));
  },
}));
